export default __webpack_public_path__ + "static/media/Newlogout.2965abca.svg";